<div *ngIf="isUserLoggedIn" class="custom-scrollbar">
    <section class="main-actions-container">
        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="getHomeRouterLink()" class="sidenav-btn"
             routerLinkActive="active"
             [ngClass]="{
      'color-blue-set': checkIsRouteActive(getHomeRouterLink()),
      'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover
    }">
            <div class="icon-area">
                <lucide-angular [img]="LayoutDashboard" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Dashboard</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="FeaturesPaths.TASKMASTER" class="sidenav-btn"
             routerLinkActive="active"
             [ngClass]="{
      'color-blue-set': checkIsRouteActive(FeaturesPaths.TASKMASTER),
      'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover
    }">
            <div class="icon-area">
                <lucide-angular [img]="SquareCheckBig" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Task Master</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="FeaturesPaths.WORKFLOW" class="sidenav-btn"
             routerLinkActive="active"
             [ngClass]="{
      'color-blue-set': checkIsRouteActive(FeaturesPaths.WORKFLOW),
      'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover
    }">
            <div class="icon-area pe-1">
                <span class="nav-icon workflow-icon"></span>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Workflow</div>
        </div>

        <div (click)="openUpdateTaskDialog()" class="sidenav-btn"
             [ngClass]="{ 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="SearchCheck" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">View Work Item</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="ActualURLPaths.MY_MEETINGS" class="sidenav-btn"
             routerLinkActive="active"
             [ngClass]="{
      'color-blue-set': checkIsRouteActive(ActualURLPaths.MY_MEETINGS),
      'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover
    }">
            <div class="icon-area">
                <lucide-angular [img]="Video" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Meetings</div>
        </div>

        <div (click)="openMeetingDialog()" class="sidenav-btn"
             [ngClass]="{ 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <mat-icon [svgIcon]="'video-join-meet'"></mat-icon>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Join Meeting</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="RootRoutePaths.DOCUMENTS" class="sidenav-btn"
             routerLinkActive="active"
             [ngClass]="{
      'color-blue-set': checkIsRouteActive(RootRoutePaths.DOCUMENTS),
      'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover
    }">
            <div class="icon-area">
                <lucide-angular [img]="FileText" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Documents</div>
        </div>
    </section>

    <div class="hr-bar">
        <div *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover" class="fs-12 cont-head">INSIGHTS</div>
        <div class="hori-line"></div>
    </div>

    <section class="sub-actions-container">
        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="FeaturesPaths.BOARD_VIEW" class="sidenav-btn"
             routerLinkActive="active"
             [ngClass]="{
      'color-blue-set': checkIsRouteActive(FeaturesPaths.BOARD_VIEW),
      'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover
    }">
            <div class="icon-area">
                <lucide-angular [img]="Columns3" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Board View</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="FeaturesPaths.MYTIMESHEET" class="sidenav-btn"
             routerLinkActive="active"
             [ngClass]="{
      'color-blue-set': checkIsRouteActive(FeaturesPaths.MYTIMESHEET),
      'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover
    }">
            <div class="icon-area">
                <lucide-angular [img]="ChartNoAxesColumn" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">My Time Sheet</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="FeaturesPaths.TIMESHEET" class="sidenav-btn"
             routerLinkActive="active"
             [ngClass]="{
      'color-blue-set': checkIsRouteActive(FeaturesPaths.TIMESHEET),
      'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover
    }">
            <div class="icon-area">
                <lucide-angular [img]="ChartColumn" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Team Time Sheet</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="ActualURLPaths.TASK_DEPENDEDNCIES"
             class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{
      'color-blue-set': checkIsRouteActive(ActualURLPaths.TASK_DEPENDEDNCIES),
      'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover
    }">
            <div class="icon-area">
                <lucide-angular [img]="ChevronsLeftRightEllipsis" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Dependencies</div>
        </div>
    </section>

    <div class="hr-bar">
        <div *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover" class="fs-12 cont-head">ADMIN PANEL</div>
        <div class="hori-line"></div>
    </div>

    <section class="sub-actions-container">
        @if (isGeoFenceActive()) {
            <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="ActualURLPaths.GEO_FENCE_ADMIN_DASHBOARD"
                 class="sidenav-btn" routerLinkActive="active"
                 [ngClass]="{ 'color-blue-set': checkIsRouteActive(ActualURLPaths.GEO_FENCE_ADMIN_DASHBOARD), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
                <div class="icon-area">
                    <lucide-angular [img]="Radar" [size]="22"/>
                </div>
                <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Geo Fence</div>
            </div>
        }

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="ActualURLPaths.EPICS_HOME"
             class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(ActualURLPaths.EPICS_HOME), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="Zap" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Epics</div>
        </div>

        <div *ngIf="isShowManageSprintBtn" [routerLinkActiveOptions]="{ exact: true }"
             [routerLink]="ActualURLPaths.SPRINTS" class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(ActualURLPaths.SPRINTS), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="FastForward" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Sprints</div>
        </div>

        <div *ngIf="isPersonalAccountPresent" [routerLinkActiveOptions]="{ exact: true }"
             [routerLink]="ActualURLPaths.PERSONAL_ORGANIZATION" class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(ActualURLPaths.PERSONAL_ORGANIZATION), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="User" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Personal</div>
        </div>

        <div *ngIf="showSuperUserButton" [routerLinkActiveOptions]="{ exact: true }"
             [routerLink]="ActualURLPaths.SUPER_ADMIN" class="sidenav-btn text-danger" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(ActualURLPaths.SUPER_ADMIN), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="Shield" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Super Admin</div>
        </div>

    </section>

    <div class="hr-bar">
        <div *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover" class="fs-12 cont-head">MISC</div>
        <div class="hori-line"></div>
    </div>

    <section class="sub-actions-container">
        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="ActualURLPaths.PERFORMANCE_FEEDBACKS"
             class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(ActualURLPaths.PERFORMANCE_FEEDBACKS), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="MessageSquareReply" [size]="22"/>
            </div>
            <div class="fsside-nav-text-16" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Feedbacks</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="FeaturesPaths.TASK_COMMENTS"
             class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(FeaturesPaths.TASK_COMMENTS), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="MessageCircle" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Comments</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="FeaturesPaths.GROUP_CONVERSATIONS"
             class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(FeaturesPaths.GROUP_CONVERSATIONS), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="MessageSquare" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Conversations</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="RootRoutePaths.TEMPLATES"
             class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(RootRoutePaths.TEMPLATES), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="SquareDashed" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Templates</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="ActualURLPaths.ATTENDANCE"
             class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(ActualURLPaths.ATTENDANCE), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="ClipboardCheck" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Attendance</div>
        </div>


        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="ActualURLPaths.GEO_FENCE_ATTENDANCE"
             class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(ActualURLPaths.GEO_FENCE_ATTENDANCE), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="Radar" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Geo Fence Attendance</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="ActualURLPaths.TIMELINE_VIEW"
             class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(ActualURLPaths.TIMELINE_VIEW), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="ChartNoAxesGantt" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Timeline</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="ActualURLPaths.LEAVE_WORKFLOW"
             class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(ActualURLPaths.LEAVE_WORKFLOW), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="CalendarMinus" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Leaves</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="ActualURLPaths.OVERTIME_WORKFLOW"
             class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(ActualURLPaths.OVERTIME_WORKFLOW), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area ">
                <span class="nav-icon overtime-icon"></span>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Overtime</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="ActualURLPaths.RELEASES_HOME"
             class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(ActualURLPaths.RELEASES_HOME), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <span class="nav-icon release-icon"></span>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Release</div>
        </div>

        <div (click)="openRemindersDialog()" class="sidenav-btn"
             [ngClass]="{ 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="BellRing" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Reminders</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="FeaturesPaths.STICKY_NOTES"
             class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(FeaturesPaths.STICKY_NOTES), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="StickyNote" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Sticky Notes</div>
        </div>

        <div [routerLinkActiveOptions]="{ exact: true }" [routerLink]="ActualURLPaths.USER_ALERTS"
             class="sidenav-btn" routerLinkActive="active"
             [ngClass]="{ 'color-blue-set': checkIsRouteActive(ActualURLPaths.USER_ALERTS), 'icon-and-text': !iconsOnlySideNavbar || !iconsOnlySideNavbarHover }">
            <div class="icon-area">
                <lucide-angular [img]="TriangleAlert" [size]="22"/>
            </div>
            <div class="side-nav-text" *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">Alerts</div>
        </div>
    </section>

    <div *ngIf="!iconsOnlySideNavbar || !iconsOnlySideNavbarHover">
        <div class="hori-line"></div>
        <div class="release-version-text csf" (click)="openReleaseNotes()">
            {{ releaseVersion }}
        </div>
    </div>

</div>